// Hero line-art per subject guide, matched on the subject name. Add one entry per new image.
const BASE = "https://customer-assets-gfyr7b9c.emergentagent.net/job_course-match-guide/artifacts/";

const ART = [
  { match: /\bmarketing\b/i, src: `${BASE}b390f83b9a886dbd_Viral%20video%2C%20empty%20chairs.png`,
    alt: "Line drawing: a performer at a microphone holds up a phone of viral likes in front of empty chairs" },
];

export const subjectArt = (name = "", slug = "") => ART.find((a) => a.match.test(name) || a.match.test(slug.replace(/-/g, " "))) || null;
